import OktaIcon from '../static/images/okta-icon.svg';

export default OktaIcon;
